import React from 'react'

import { greyMultibrandPalette, CustomTheme } from '@masfront/common-b2c'

import { Box } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import TabPanel from '@material-ui/lab/TabPanel'

import useCustomer from '../useCustomer'

import { PersonalDataTabContainer } from '~/customer/components'
import tabConfigs from '~/customer/containers/tabsConfig'
import { getFullName } from '~/customer/helpers/customer.helpers'
import { B2CTabContextList, B2CPage } from '~/ui/components'

const useStyles = makeStyles((theme: CustomTheme) => {
  return {
    tabPanel: {
      marginTop: theme.spacing(2),
      backgroundColor: greyMultibrandPalette[50],
      minHeight: '90vh',
      padding: theme.spacing(2, 0),
    },
    tabsRoot: {
      padding: theme.spacing(0, 6),
    },
  }
})

const CustomerPageContainer: React.FC = () => {
  const classes = useStyles()
  const { customer } = useCustomer()

  const styleClasses = {
    tabsRoot: classes.tabsRoot,
  }

  const title = customer?.business ? customer.business.company : getFullName(customer)

  return (
    <Box>
      {customer && (
        <B2CPage title={title}>
          <Box pt={2} />
          <B2CTabContextList classes={styleClasses} tabConfigs={tabConfigs} queryParam="tab">
            <TabPanel className={classes.tabPanel} value={tabConfigs[0].value}>
              <PersonalDataTabContainer />
            </TabPanel>
          </B2CTabContextList>
        </B2CPage>
      )}
    </Box>
  )
}

export default CustomerPageContainer
